
(function () {
  const script = document.createElement('script')
  script.src = 'https://a.klaviyo.com/media/js/onsite/onsite.js';
  (document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]).appendChild(script)
  script.onload = () => {
    window.klaviyo.init({
      account: window.Shopify.currency.active === "CHF" ? "SN7WMZ" : "Tnmznh",
      platform: "shopify"
    });

    window.klaviyo.enable("backinstock",{
      trigger: {
        product_page_text: window.klaviyo_i18n.trigger.product_page_text,
        product_page_class: "btn btn--primary",
        product_page_text_align: "center",
        product_page_margin: "0px",
        replace_anchor: false
      },
      modal: {
        headline: window.klaviyo_i18n.modal.headline,
        body_content: window.klaviyo_i18n.modal.body_content,
        email_field_label: window.klaviyo_i18n.modal.email_field_label,
        button_label: window.klaviyo_i18n.modal.button_label,
        subscription_success_label: window.klaviyo_i18n.modal.subscription_success_label,
        footer_content: '',
        additional_styles: "",
        drop_background_color: "#000",
        background_color: "#fff",
        text_color: "#000",
        button_text_color: "#fff",
        button_background_color: "#514288",
        close_button_color: "#ccc",
        error_background_color: "#e8b6b6",
        error_text_color: "#f36161",
        success_background_color: "#b8d5b2",
        success_text_color: "#3dad29"
      }
    });

    let counter = 0
    tryMove()
    function tryMove () {
      if (counter > 10) {
        return
      }
      counter++

      const button = document.querySelector('.klaviyo-bis-trigger')
      if (button) {
        const icon = document.createElement('img')
        icon.src = window.klaviyo_i18n.icon
        button.prepend(icon)

        button.style.display = ''
        document.querySelector('.product-details-wrapper #AddToCartForm .paymentButtonsWrapper')
          .append(button)

        document.querySelector('#StickyAddToCartForm .f-sticky-atc-foot')
          .append(button.cloneNode(true))

        return
      }

      setTimeout(tryMove, 1000)
    }
  }
})()
